import { supportsUnifiedNativeMainShell } from "./nativeMultiTabShellGate";

declare global {
  interface Window {
    /** 新版 App 可选注入，仅作调试/遥测；门控以 {@link supportsUnifiedNativeMainShell} build 为准。 */
    __EDGEN_UNIFIED_MAIN_SHELL__?: boolean;
  }
}

/**
 * 当前是否应走「统一主壳」Web 分支（Brief/Invest/Plan 单 WebView）。
 * 以 {@link supportsUnifiedNativeMainShell}（build 门控）为准，不依赖原生 JS 注入。
 */
export function isUnifiedNativeMainShell(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return supportsUnifiedNativeMainShell();
}
